module.exports = __webpack_public_path__ + "img/SamsungA20.16555818.png";